export default __webpack_public_path__ + "static/media/icon_downlight_on.19b72841.png";